import { getDecodeToken } from "security";
import { isEmpty } from 'lodash';
import { Sale } from "types/type";
import 'moment-timezone';
import moment from 'moment';

export const isCancelableSale = (record: Sale): boolean => {
    if (record.cancelable) {
        if (isEmpty(getDecodeToken().customerCode)) {
            return true;
        } else return record.clientCancel;
    }
    return false;
};

export const isCancelable = (record: Sale): boolean => {
    if (record.cancelable && ['XAXX010101000', 'AAA010101AAA'].includes(record.invoiceRfc)) {
        if (isEmpty(getDecodeToken().customerCode)) {
            return true;
        } else return record.clientCancel;
    }
    return false;
};

export const subStringWithEllipsis = (str: string, end: number): string => {
    const substr = str.substring(0, end);
    return substr.length < str.length ? substr + '...' : substr;
};


export const formatStringDateToDisplay = (date: string, resultFormat: string = 'YYYY-MM-DD HH:mm:ss') => {
    // const dateMoment = moment.parseZone(date);
    const dateMoment = moment(date);
    return dateMoment.isValid() ? dateMoment.format(resultFormat) : 'N/A';
}

export const mexStringDateToDisplay = (date: string, resultFormat: string = 'YYYY-MM-DD HH:mm:ss') => {
    const mexicoDate = moment.tz(date, 'YYYY-MM-DD HH:mm:ss', 'America/Mexico_City');
    const localDate = mexicoDate.clone().tz(moment.tz.guess());
    return localDate.isValid() ? localDate.format(resultFormat) : 'N/A';
}

export const formatNumberToDisplay = (input: number | string, digits: number = 2): string => {
    const parsed = typeof input === 'string' ? Number(input) : input;

    if (isNaN(parsed)) {
        throw new Error(`Invalid number input: ${input}`);
    }

    return Number(parsed.toFixed(digits)).toLocaleString(undefined, {
        maximumFractionDigits: digits,
    });
};

export const toParameters = (obj: Record<string, string | number | boolean>): string => {
    const queryString = Object.entries(obj)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return queryString ? `?${queryString}` : '';
};

export const toTitleCase = (str: String): string => {
    return str.replace(
        /\w\S*/g,
        text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
}

export function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.split(",")[1]); // quita el prefijo "data:...;base64,"
    };

    reader.onerror = (error) => reject(error);

    reader.readAsDataURL(file);
  });
}